import { useLocation } from "react-router-dom";

/** The page answers at /evidence-api and at its short alias /evidence. */
export const PAGE_BASES = ["/evidence-api", "/evidence"] as const;

/** The base the visitor is on, so permalinks and the login return keep it. */
export const useEvidenceBase = (): string =>
  useLocation().pathname.startsWith("/evidence-api") ? "/evidence-api" : "/evidence";

export const loginUrl = (base: string): string => `/login?next=${encodeURIComponent(base)}`;
